import classNames from 'classnames';
import Button, {
  Props as ButtonProps
} from '../../Atoms/Button';
import Title from '../../Atoms/Title';
import Text from '../../Atoms/Text';

interface Props {
  title: string;
  text: string;
  button?: ButtonProps;
  color?: 'blue' | 'gray';
  className?: string;
}

function CardDefault({
  title,
  text,
  color = 'blue',
  button,
  className
}: Props) {
  return (
    <div
      className={classNames([
        'flex flex-col gap-5 rounded-xl p-7 md:py-12 md:px-12 lg:px-16',
        color === 'blue' && 'bg-sl-indigo text-white',
        color === 'gray' && 'bg-sl-gray-light text-sl-blue',
        className
      ])}
    >
      <Title as="h2" size={4} color="inherit">
        {title}
      </Title>
      <Text color="inherit" className="mb-2 max-w-sm">
        {text}
      </Text>
      {button && (
        <div className="mt-auto">
          <Button
            color={
              color === 'blue'
                ? 'accent'
                : 'secondary-outline'
            }
            {...button}
          />
        </div>
      )}
    </div>
  );
}

export default CardDefault;
